// const { city, country_name: country, region } = window._addressInfo;

export const getSuperProperties = () => ({
  referringDomain: window.location.hostname
  // city,
  // country,
  // region
});
